"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT = void 0;
const Actions = __importStar(require("../actions/types"));
exports.DEFAULT = {
    formalAttributesMap: new Map(),
    formalAttributeValuesMap: new Map(),
    attributes: [],
    attributeValuesMap: {},
    oldAttributeValuesMap: new Map(),
};
const attributesSetFormalAttributes = (state, formalAttributes) => {
    if (formalAttributes.length) {
        // create a copy so that useEffect hooks see this as a new map.
        const formalAttributesMap = new Map(state.formalAttributesMap);
        formalAttributes.forEach((formalAttribute) => formalAttributesMap.set(formalAttribute.id, formalAttribute));
        return Object.assign(Object.assign({}, state), { formalAttributesMap });
    }
    return state;
};
const attributesSetFormalAttributeValues = (state, formalAttributeValues) => {
    if (formalAttributeValues.length) {
        // create a copy so that useEffect hooks see this as a new map.
        const formalAttributeValuesMap = new Map(state.formalAttributeValuesMap);
        formalAttributeValues.forEach((formalAttributeValue) => formalAttributeValuesMap
            .set(formalAttributeValue.id, formalAttributeValue));
        return Object.assign(Object.assign({}, state), { formalAttributeValuesMap });
    }
    return state;
};
const attributesSetAttributes = (state, { attributes, isMultiFacetNavEnabled }) => (Object.assign(Object.assign(Object.assign({}, state), { attributes: [...attributes] }), (isMultiFacetNavEnabled && {
    attributeValuesMap: [...attributes].reduce((attributesMap, actualAttribute) => {
        var _a;
        attributesMap[actualAttribute.attributeId] = ((_a = attributesMap[actualAttribute.attributeId]) !== null && _a !== void 0 ? _a : []).concat(actualAttribute);
        return attributesMap;
    }, {}),
})));
const attributesSetValuesMap = (state, attributeValuesMap) => (Object.assign(Object.assign({}, state), { oldAttributeValuesMap: new Map(attributeValuesMap) }));
exports.default = (state = exports.DEFAULT, action) => {
    switch (action.type) {
        case Actions.ATTRIBUTES_SET_FORMAL_ATTRIBUTES:
            return attributesSetFormalAttributes(state, action.payload);
        case Actions.ATTRIBUTES_SET_FORMAL_ATTRIBUTE_VALUES:
            return attributesSetFormalAttributeValues(state, action.payload);
        case Actions.ATTRIBUTES_SET_ATTRIBUTES:
            return attributesSetAttributes(state, action.payload);
        case Actions.ATTRIBUTES_SET_VALUES_MAP:
            return attributesSetValuesMap(state, action.payload);
        default:
            return state;
    }
};
